<template>
  <div class="organization">
    <!-- <h1>acquirer</h1> -->
    <v-snackbar
      v-model="snackbar"
      :timeout="6000"
      :color="snackbar_color"
      location="top"
      max-height="10cm"
      max-width="5cm"
      multi-line
    >
      {{ snackbar_text }}
    </v-snackbar>

    <v-row no-gutters class="mt-2">
      <v-col cols="auto" class="me-auto">
        <!-- <v-sheet class="ma-2 pa-2">Acquirer</v-sheet> -->
        <v-sheet>
          <v-breadcrumbs
            :items="[
              { text: $t('currencies'), disabled: true, href: '/' },
            ]"
          ></v-breadcrumbs>
        </v-sheet>
      </v-col>
      <v-col cols="auto">
        <v-sheet>
          <!-- <v-btn class="text-none text-subtitle-1" color="#5865f2" size="small" variant="flat" >Add Acquirer</v-btn>             -->
          <!-- <v-btn density="compact">Add Acquirer</v-btn>  -->
          <v-btn
            class="button_size"
            color="blue"
            prepend-icon="mdi-plus"
            @click="compose"
            v-if="
              this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
              this.global_permissions.includes('ROLE_STAFF_USER')
            "
          >
            <template v-slot:prepend>
              <v-icon color="white"></v-icon>
            </template>
            {{ $t("add_currency") }}
          </v-btn>
        </v-sheet>
      </v-col>
    </v-row>

    <v-row class="search_row">
      <v-col cols="3">
        <v-text-field
          :loading="loading"
          append-inner-icon="mdi-close-circle"
          append-icon="mdi-magnify"
          density="compact"
          :label="$t('search')"
          variant="solo"
          hide-details
          single-line
          dense
          v-model="query"
          @click:append-inner="resetData"
          @click:append="searchData"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- Loading Spinner -->
    <v-progress-circular
      v-if="loading"
      indeterminate
      color="blue"
      size="25"
      class="loading-spinner"
    ></v-progress-circular>

    <v-card v-else>
      <v-data-table
        :headers="headers"
        :items="currencies"
        class="elevation-1 custom-table-style"
        :search="search"
        :items-per-page="itemsPerPage"
        :items-length="totalItems"
        disable-pagination
        :hide-default-footer="true"
        :fixed-header="true"
        :loading="loading"
      >
        <template v-slot:item.actions="{ item }">
          <v-tooltip :text="$t('Update')" location="top">
            <template v-slot:activator="{ props }">
              <v-icon
                v-bind="props"
                small
                class="mr-2"
                color="green"
                @click="compose_update(item.raw.currencyCode)"
                v-if="this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
              this.global_permissions.includes('ROLE_STAFF_USER')"
                >mdi-pencil-circle</v-icon
              >
            </template>
          </v-tooltip>
          <v-tooltip :text="$t('Delete')" location="top">
            <template v-slot:activator="{ props }">
              <v-icon
                v-bind="props"
                small
                class="mr-2"
                color="red"
                @click="compose_delete(item.raw.currencyCode)"
                v-if="this.global_permissions.includes('ROLE_STAFF_ADMIN')"
                >mdi-delete-circle</v-icon
              >
            </template>
          </v-tooltip>
        </template>

        <template v-slot:bottom>
          <div class="text-center pt-2">
            <v-pagination
              v-model="page"
              :length="pageCount"
              :total-visible="pageCount < 3 ? 3 : 7"
              @update:model-value="page"
            ></v-pagination>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <!-- ADD ORG DIALOG -->
    <v-dialog v-model="dialog" persistent width="800">
      <v-card>
        <v-form v-model="form" @submit.prevent="onSubmit">
          <v-container>
            <v-card-title>
              <span class="text-h5"> {{ $t("add_currency") }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      :label="$t('currency_name')"
                      :readonly="loading"
                      :rules="[required]"
                      clearable
                      v-model="currency_data.f_currencyName"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      :label="$t('currency_O_name')"
                      :readonly="loading"
                      :rules="[required]"
                      clearable
                      v-model="currency_data.f_currencyOtherName"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      :label="$t('currency_code')"
                      :readonly="loading"
                      :rules="[required]"
                      clearable
                      v-model="currency_data.f_currencyCode"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      :label="$t('minor_digit')"
                      :readonly="loading"
                      :rules="[required]"
                      clearable
                      v-model="currency_data.f_minorDigit"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
              <small>*{{ $t("indicateRequires") }}</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn variant="text" @click="dialog = false">{{
            $t("Close")
          }}</v-btn>
              <v-btn
                color="success"
                type="submit"
                variant="text"
                @click="addCurrency"
                >{{ $t("Save") }}</v-btn
              >
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- END ADD ACQUIRER DIALOG -->

    <!-- UPDATE ACQUIRER DIALOG -->
    <v-dialog v-model="dialog_update" persistent width="800">
      <v-card>
        <v-form v-model="form" @submit.prevent="onSubmit">
          <v-container>
            <v-card-title>
              <span class="text-h5">{{ $t("update_currency") }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                       :label="$t('currency_name')"
                      :readonly="loading"
                      :rules="[required]"
                      clearable
                      v-model="currency_data.f_currencyName"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                       :label="$t('currency_O_name')"
                      :readonly="loading"
                      :rules="[required]"
                      clearable
                      v-model="currency_data.f_currencyOtherName"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      :label="$t('currency_code')"
                      :readonly="loading"
                      :rules="[required]"
                      clearable
                      v-model="currency_data.f_currencyCode"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                       :label="$t('minor_digit')"
                      :readonly="loading"
                      clearable
                      v-model="currency_data.f_minorDigit"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
              <small>*{{ $t("indicateRequires") }}</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn variant="text" @click="dialog_update = false">{{
            $t("Close")
          }}</v-btn>
              <v-btn
                color="success"
                type="submit"
                variant="text"
                @click="updateCurrency"
                >{{ $t("Update") }}</v-btn
              >
            </v-card-actions>
          </v-container>
        </v-form>
      </v-card>
    </v-dialog>
    <!-- END UPDATE  DIALOG -->

    <!-- DELETE  DIALOG -->
    <!-- <v-dialog
              v-model="dialog_delete"
              persistent
              width="500"
            >              
              <v-card>
                <v-card-title>
                  <span class="text-h5">do you want to delete?</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                                           
                    </v-row>
                  </v-container>
                  
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue-darken-1" variant="text" @click="dialog_delete = false">Close</v-btn>                  
                  <v-btn color="blue-darken-1" variant="text" @click="deleteCurrency">Delete</v-btn>                 
                </v-card-actions>
              </v-card>
            </v-dialog> -->

    <v-dialog v-model="dialog_delete" persistent width="400">
      <v-card>
        <template v-slot:title>
          <span class="font-weight-medium-black">{{ $t("deleteFile") }}</span>
        </template>

        <v-card-text class="bg-surface-light py-4">
          {{ $t("deleteText") }}
        </v-card-text>
        <v-card-actions class="mb-2 mr-2">
          <v-spacer></v-spacer>
          <v-btn color="red" variant="flat" @click="deleteCurrency">{{
            $t("Delete")
          }}</v-btn>
          <v-btn variant="flat" @click="dialog_delete = false">{{
            $t("Close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- END UPDATE DIALOG -->
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "Acquirer",
  props: {
    msg: String,
  },
  data() {
    return {
      name: "",
      emits: ["reload"],
      currencies: [],

      dialog: false,
      dialog_update: false,
      dialog_delete: false,

      currency_data: {
        f_currencyName: "",
        f_currencyOtherName: "",
        f_currencyCode: "",
        f_minorDigit: "",
      },

      currencyId: "",
      search: "",
      headers: [
        {
          title: this.$t("currency_name"),
          align: "start",
          sortable: false,
          key: "currencyName",
        },
        { title: this.$t("currency_O_name"), key: "currencyOtherName" },
        { title: this.$t("currency_code"), key: "currencyCode" },
        { title: this.$t("minor_digit"), key: "minorDigit" },
        { title: this.$t("Actions"), key: "actions", sortable: false },
      ],

      //form
      form: false,
      loading: false,

      //snackbar
      snackbar: false,
      snackbar_text: "",
      snackbar_color: "",

      //pagination
      page: 1,
      itemsPerPage: 5,
      totalItems: 0,
      totalPages: 0,
      query: "",
    };
  },

  created() {},

  computed: {
    pageCount() {
      // console.log("ssss", this.totalItems + " / " + this.itemsPerPage);
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
  },

  watch: {
    page(newPage) {
      this.page = newPage;
      this.fetchData();
      // console.log("new page", this.page);
    },

    onUpdatePageHandler(newPage) {
      this.page = newPage;
      //this.fetchData()
    },

    onItemsPerPageChange(newItemsPerPage) {
      this.itemsPerPage = newItemsPerPage;
      this.fetchData();
    },
  },

  methods: {
    onSubmit() {
      if (!this.form) return;
    },

    resetData() {
      this.query = "";
      this.fetchData();
    },

    resetInput(){
        this.currency_data.f_currencyName = "";
        this.currency_data.f_currencyOtherName = "";
        this.currency_data.f_currencyCode = "";
        this.currency_data.f_minorDigit = "";
    },

    required(v) {
      return !!v || "Field is required";
    },

    show_toast(status, color, text) {
      this.snackbar = status;
      this.snackbar_color = color;
      this.snackbar_text = text;
    },

    compose() {
      this.dialog = true;
      this.resetInput();
      this.checkTokenExpiry();
      //this.requests_handler()
    },

    compose_update(id) {
      this.currencyId = id;
      this.dialog_update = true;
      this.checkTokenExpiry();
      // console.log("id", id);
      this.requests_handler2();
    },

    compose_delete(id) {
      this.currencyId = id;
      this.dialog_delete = true;
    },

    async addCurrency() {
      this.checkTokenExpiry();
      try {
        // console.log("form data", this.currency_data);
        let result = await axios.post(
          window.baseurl + "currencies",
          {
            currencyName: this.currency_data.f_currencyName,
            currencyOtherName: this.currency_data.f_currencyOtherName,
            currencyCode: this.currency_data.f_currencyCode,
            minorDigit: this.currency_data.f_minorDigit,
          },
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );
        //console.warn("result", result);
        if (result.status == 201) {
          //alert("successfull");
          //this.show_toast(true, "success", "Successful");
          // this.$root.vtoast.show({message: result.data.message})
          this.$root.vtoast.show({ message: this.$t("currency_created") });
          window.setInterval(() => {
            this.dialog = false;
            this.$emit("reload");
          }, this.wainting_time);
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        if(error.response.status == 417){
            this.$root.vtoast.showError({message: error.response.data.message})
          }else if(error.response.status == 500){
            this.$root.vtoast.showError({message: error.response.data.detail})
          }else{
            this.$root.vtoast.showError({message: error.response.data.message})
          }
      }
    },

    requests_handler2() {
      axios
        .all([
          axios.get(window.baseurl + "" + "currencies/" + this.currencyId, {
            headers: { Authorization: "Bearer " + this.accessToken },
          }),
        ])
        .then(
          axios.spread((currency_response) => {
            // console.log("data1", currency_response.data);

            //get data for selected id and display data in for dialog
            if (currency_response.status == 200) {
              //this.acquirer_response = acquirer_response.data,
              // console.log("currency Data", this.currency_response);
              this.currency_data.f_currencyName = currency_response.data.currencyName;
              this.currency_data.f_currencyOtherName = currency_response.data.currencyOtherName;
              this.currency_data.f_currencyCode = currency_response.data.currencyCode;
              this.currency_data.f_minorDigit = currency_response.data.minorDigit;
            }
          })
        );
    }, //end of requests_handler 2 method

    async updateCurrency() {
      //this.dialog_update = false
      this.checkTokenExpiry();
      try {
        // console.log("update form curr id", this.currencyId);
        // console.log("update form curre..", this.currency_data);
        let result = await axios.put(
          window.baseurl + "" + "currencies/" + this.currencyId,
          {
            currencyName: this.currency_data.f_currencyName,
            currencyOtherName: this.currency_data.f_currencyOtherName,
            currencyCode: this.currency_data.f_currencyCode,
            minorDigit: this.currency_data.f_minorDigit,
          },
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );
        // console.log("update form currency result", result);
        if (result.status == 200) {
          // this.$root.vtoast.show({message: result.data.message})
          this.$root.vtoast.show({ message: this.$t("currency_updated") });
          window.setInterval(() => {
            this.dialog = false;
            this.$emit("reload");
          }, this.wainting_time);
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        if(error.response.status == 417){
            this.$root.vtoast.showError({message: error.response.data.message})
          }else if(error.response.status == 500){
            this.$root.vtoast.showError({message: error.response.data.detail})
          }else{
            this.$root.vtoast.showError({message: error.response.data.message})
          }
      }
    },

    async deleteCurrency() {
      this.dialog_delete = false;
      try {
        let result = await axios.delete(
          window.baseurl + "currencies/" + this.currencyId,
          { headers: { Authorization: "Bearer " + this.accessToken } }
        );
        if (result.status == 204) {
          // this.$root.vtoast.show({message: result.data.message})
          this.$root.vtoast.show({ message: this.$t("currency_deleted") });
          window.setInterval(() => {
            this.$emit("reload");
          }, this.wainting_time);
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.message });
      }
    },

    async fetchData() {
      // console.log("in fecthData", this.page);
      let result;
      this.loading = true;
      let page2 = this.page - 1;
      try {
        if (
          this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
              this.global_permissions.includes('ROLE_STAFF_USER')
        ) {
          result = await axios.get(window.baseurl + "currencies", {
            params: { page: page2 },
            headers: { Authorization: "Bearer " + this.accessToken },
          });

          // console.log("currencies_object", result);
          this.currencies = result.data.records;
          this.totalItems = result.data.totalRecords; // Set the total number of items
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          //this.page = result.data.currentPage

          this.loading = false;
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.message });
        this.loading = false;
      }
    },

    async searchData() {
      // console.log("in searchData", this.query);
      this.checkTokenExpiry();
      let result;
      this.loading = true;
      let page2 = this.page - 1;
      try {
        if (
          this.global_permissions.includes('ROLE_STAFF_ADMIN') ||
          this.global_permissions.includes('ROLE_STAFF_USER')
        ) {
          result = await axios.get(window.baseurl + "currencies/search", {
            params: { page: page2, search: this.query },
            headers: { Authorization: "Bearer " + this.accessToken },
          });

          // console.log("currencies_search_object", result);
          this.currencies = result.data.records;
          this.totalItems = result.data.totalRecords; // Set the total number of items
          this.itemsPerPage = result.data.pageSize;
          this.totalPages = result.data.totalPages;
          //this.page = result.data.currentPage

          this.loading = false;
        }
      } catch (error) {
        //this.show_toast(true, "warning", error.message);
        this.$root.vtoast.showError({ message: error.message });
        this.loading = false;
      }
    },
  },
  //get list of acquirers
  async mounted() {
    this.checkTokenExpiry();

    //get data for table
    this.fetchData();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
